import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';

import { RegexConst } from '@consts';
import { ForgotPasswordResponseCodesEnum } from '@shared/enums';
import { IForgotPasswordBody } from '@shared/models';
import { AuthService } from '@shared/providers/external/auth.service';
import { AlertService } from '@shared/providers/utilities/alert.service';
import { LoaderService } from '@shared/providers/utilities/loader.service';

@Component({
    selector: 'anp-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent {
  public formData: FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.pattern(RegexConst.EMAIL)]],
    document: ['', [Validators.required, Validators.minLength(11), Validators.maxLength(11)]]
  });

  private modal: HTMLIonModalElement; /// Este es el mismo modal que esta mostrando el componente

  constructor(
    private auth: AuthService,
    private loaderService: LoaderService,
    private fb: FormBuilder,
    private alertService: AlertService
  ) {}

  public get email(): AbstractControl<string> {
    return this.formData?.get('email');
  }

  public get document(): AbstractControl<string> {
    return this.formData?.get('document');
  }

  public async dismiss(): Promise<void> {
    await this.modal.dismiss();
  }

  /**
   * Activa el loader y espera por la respuesta del server
   */
  public async submit(): Promise<void> {
    const formData: IForgotPasswordBody = {
      email: this.email.value,
      username: this.document.value
    };

    const loader = await this.loaderService.simpleLoader();
    await loader.present();
    try {
      const resp = await this.auth.resetPassword(formData);
      switch (String(resp.Code)) {
        case ForgotPasswordResponseCodesEnum.SUCCESS:
          this.alertService.simpleAlert(
            'Correo enviado',
            'Se envió un enlace de verificación al correo ' + this.email.value,
            ['Aceptar'],
            false
          );
          await this.modal.dismiss();
          break;
        case ForgotPasswordResponseCodesEnum.DOCUMENT_NOT_FOUND:
          this.alertService.simpleAlert('Error', 'Esta cedula no corresponde a ningun miembro de la policia', [
            'Entendido'
          ]);
          break;
        case ForgotPasswordResponseCodesEnum.MEMBER_INACTIVE:
          this.alertService.simpleAlert('Error', 'El miembro de la policia no esta activo', ['Entendido']);
          break;
        case ForgotPasswordResponseCodesEnum.EMAIL_DOESNT_MATCH:
          this.alertService.simpleAlert('Error', 'El correo electronico no coincide con el usuario', ['Entendido']);
          break;
        case ForgotPasswordResponseCodesEnum.EMAIL_NOT_FOUND:
          this.alertService.simpleAlert('Error', 'No existe un usuario con este correo electronico', ['Entendido']);
          break;
        case ForgotPasswordResponseCodesEnum.EMAIL_NOT_SENT:
          this.alertService.simpleAlert(
            'No se pudo enviar el correo electronico',
            'Por favor intente mas tarde, si el problema persiste contacte a recursos humanos',
            ['Entendido']
          );
          break;
        case ForgotPasswordResponseCodesEnum.ANP_ERROR:
          this.alertService.simpleAlert(
            'Error',
            'No se pudo establecer conexion con el servidor de la Policía Nacional, intente mas tarde'
          );
          break;
        default:
          this.alertService.simpleAlert('Error', 'No se pudo reestablecer la contraseña', ['Entendido']);
          break;
      }

      await loader.dismiss();
    } catch (error) {
      await this.alertService.simpleAlert('Error', 'Hubo un error con el servidor, intente mas tarde', ['Entendido']);
      await loader.dismiss();
    }

    await loader.present();
  }
}
